import * as yup from "yup";
import { farsiCharsRegex, phoneNumberRegex } from "../regex";

export const contact_us = yup.object({
  firstName: yup
    .string()
    .trim()
    .min(2, "تعداد کاراکتر واردشده کمتر از حد مجاز است.")
    .max(50, "تعداد کاراکتر واردشده بیشتر از حد مجاز است.")
    .matches(farsiCharsRegex, "لطفا فقط حروف فارسی وارد کنید")
    .required("لطفا نام را وارد کنید."),
  lastName: yup
    .string()
    .trim()
    .min(2, "تعداد کاراکتر واردشده کمتر از حد مجاز است.")
    .max(128, "تعداد کاراکتر واردشده بیشتر از حد مجاز است.")
    .matches(farsiCharsRegex, "لطفا فقط حروف فارسی وارد کنید")
    .required("لطفا نام خانوادگی را وارد کنید."),
  businessTitle: yup
    .string()
    .trim()
    .min(3, "تعداد کاراکتر واردشده کمتر از حد مجاز است.")
    .max(128, "تعداد کاراکتر واردشده بیشتر از حد مجاز است."),
  title: yup
    .string()
    .trim()
    .min(2, "تعداد کاراکتر واردشده کمتر از حد مجاز است.")
    .max(128, "تعداد کاراکتر واردشده بیشتر از حد مجاز است.")
    .required("لطفا عنوان پیام را وارد کنید."),
  text: yup.string().required("لطفا متن پیام خود را وارد کنید."),
  phoneNumber: yup
    .string()
    .matches(phoneNumberRegex, "لطفا یک شماره تلفن‌همراه معتبر وارد کنید.")
    .max(11, "شماره تلفن‌همراه باید 11 رقم باشد.")
    .min(11, "شماره تلفن‌همراه باید 11 رقم باشد.")
    .required("لطفا شماره تماس خود را وارد کنید."),
  email: yup
    .string()
    .email("لطفا یک ایمیل معتبر وارد کنید.")
    .matches(/@[^.]*\./, "لطفا یک ایمیل معتبر وارد کنید.")
    .required("لطفا ایمیل خود را وارد کنید"),
  subject: yup.string().required("موضوع نمی تواند خالی باشد.").nullable(),
  category: yup.string().required("دسته‌بندی نمی تواند خالی باشد.").nullable(),
  subcategory: yup.string().required("زیردسته نمی تواند خالی باشد.").nullable(),
});
